export default __webpack_public_path__ + "static/media/RobotoMono-VariableFont_wght.27b8c040.woff";